import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { AdminWalletBankResponse } from '../types/api/user.types';

interface UsersState {
  loading: boolean;
  setLoading: (value: boolean) => void;
  bank: AdminWalletBankResponse | null;
  setBank: (value: AdminWalletBankResponse) => void;
  addBankModal: boolean;
  setAddBankModal: (value: boolean) => void;
  connectYourBankModal: boolean;
  setConnectYourBankModal: (value: boolean) => void;
  deleteBankModal: boolean;
  setDeleteBankModal: (value: boolean) => void;
  editBalanceModal: boolean;
  setEditBalanceModal: (value: boolean) => void;
  editPendingBalanceModal: boolean;
  setEditPendingBalanceModal: (value: boolean) => void;
}

export const useUsers = create<UsersState>()(
  devtools(
    (set) => ({
      loading: false,
      setLoading: (value) => set(() => ({ loading: value })),
      bank: null,
      setBank: (value) => set(() => ({ bank: value })),
      addBankModal: false,
      setAddBankModal: (value) => set(() => ({ addBankModal: value })),
      connectYourBankModal: false,
      setConnectYourBankModal: (value) =>
        set(() => ({ connectYourBankModal: value })),
      deleteBankModal: false,
      setDeleteBankModal: (value) => set(() => ({ deleteBankModal: value })),
      editBalanceModal: false,
      setEditBalanceModal: (value) => set(() => ({ editBalanceModal: value })),
      editPendingBalanceModal: false,
      setEditPendingBalanceModal: (value) =>
        set(() => ({ editPendingBalanceModal: value })),
    }),
    { name: 'users' }
  )
);
